export const blockIconsAudioandvideoAlbumNew = (
	<span className='material-symbols-outlined'>album</span>
);
